'use strict';
require('../../modules/es.array.includes');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'includes');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/array/includes.js
// module id = 337
// module chunks = 0